export default __webpack_public_path__ + "static/media/type-bar.e93440e8.svg";